export default {
	seo_meta_title_leaguepass: 'NBA | Videos y puntos destacado de la NBA',
	seo_meta_desc_leaguepass: 'NBA Video incluye videos y puntos detstacados de la NBA',
	seo_meta_keywords_leaguepass: 'Videos de la NBA, puntos destacados de la NBA, videos de baloncesto, mejores jugadas, mates, características',
	seo_meta_title_featured: 'NBA | Destacados',
	seo_meta_desc_featured: '',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA | NBA TV Live',
	seo_meta_desc_nbatv: 'NBA TV Live es tu transmisión en vivo, 24 horas al día, del canal NBA TV que emite partidos en vivo y de archivo de la NBA cada semana, programas de estudio y cobertura de analistas',
	seo_meta_keywords_nbatv: 'Canal NBA TV, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, studio shows, the jump',
	seo_meta_title_classicgames: 'NBA | Juegos clásicos',
	seo_meta_desc_classicgames: '',
	seo_meta_keywords_classicgames: '',
	seo_meta_title_videolist: 'NBA | Lista de videos',
	seo_meta_desc_videolist: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'NBA | Programas de NBA TV',
	seo_meta_desc_shows: '',
	seo_meta_keywords_shows: '',
	seo_meta_title_home: 'Inicio NBA',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'NBA | Canales',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'NBA | Canal',
	seo_meta_pre_title_categories: 'NBA | Categorías',
	seo_meta_title_categories: 'NBA | {0}',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'NBA | Categoría',
	seo_meta_title_category: 'NBA | {0}',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'NBA | Video',
	seo_meta_pre_title_event: 'NBA | Evento',
	seo_meta_title_events: 'NBA | Eventos',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: 'NBA | Eventos: {0}',
	seo_meta_desc_event: '',
	seo_meta_keywords_event: '',
	seo_meta_title_search: 'NBA | Búsqueda',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'NBA | Página no encontrada',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'NBA Game:',
	seo_meta_title_game: 'NBA | {0}',
	seo_meta_desc_game: '',
	seo_meta_keywords_game: '',
	seo_meta_title_video: 'NBA | Videos y puntos destacado de la NBA',
	seo_meta_desc_video: 'NBA Video incluye videos y puntos detstacados de la NBA',
	seo_meta_keywords_video: 'Videos de la NBA, puntos destacados de la NBA, videos de baloncesto, mejores jugadas, mates, características',
	seo_meta_title_channel: 'NBA | NBA TV Live',
	seo_meta_desc_channel: 'NBA TV Live es tu transmisión en vivo, 24 horas al día, del canal NBA TV que emite partidos en vivo y de archivo de la NBA cada semana, programas de estudio y cobertura de analistas',
	seo_meta_keywords_channel: 'Canal NBA TV, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, studio shows, the jump',
	seo_meta_title_tvguide: 'NBA | Programación NBA TV',
	seo_meta_desc_tvguide: 'NBA TV Live es tu transmisión en vivo, 24 horas al día, del canal NBA TV que emite partidos en vivo y de archivo de la NBA cada semana, programas de estudio y cobertura de analistas',
	seo_meta_keywords_tvguide: 'Canal NBA TV, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, studio shows, the jump',
	timezone: 'ET',
	default_feed_error_message: 'Algo salió mal, el contenido no está disponible ahora. Intenta más tarde.',
	watch_in_app: 'MÍRALO EN LA APP DE NBA',
	no_content: 'Sin contenido',
	see_more: 'Ver más',
	now_playing: 'EN REPRODUCCIÓN',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'League Pass',
	league_pass_premium_lock: 'LP PREMIUM',
	error_max_limit_favorite: 'Haz alcanzado el número máximo de videos favoritos. Elimina algunos antes de añadir más.',
	item_live: 'EN VIVO',
	add_favourite_title: 'AGREGAR A FAVORITOS',
	remove_favourite_title: 'QUITAR DE FAVORITOS',
	p_channel_live: 'EN VIVO',
	p_channel_schedule_title: 'Programación NBA TV',
	p_channel_schedule_watch: 'Ver',
	p_channel_schedule_no_date: 'Actualmente no hay fecha de programación disponible.',
	p_channel_live24x7_title: 'NBA TV 24/7',
	p_channel_live24x7_see_full_schedule: 'Ver programación completa',
	p_channel_live24x7_up_next: 'A continuación',
	p_channel_live24x7_on_demand: 'NBA TV: On Demand',
	p_channel_live24x7_collection: 'Colección',
	p_channel_live24x7_demand_1_logo_text: 'Shows originales',
	p_channel_live24x7_demand_1_show_name: 'Shows de NBA TV',
	p_channel_live24x7_demand_1_show_desc: 'Programas originales de NBA TV que incluyen Shaqtin’a Fool, Beyond the Paint, Game Time y Basketball Stories',
	p_channel_live24x7_demand_2_logo_text: 'Partidos clásicos',
	p_channel_live24x7_demand_2_show_name: 'NBA | Juegos clásicos',
	p_channel_live24x7_demand_2_show_desc: 'Mira partidos clásicos completos, incluidos todas las finales desde 2000, momentos históricos de la liga y jugadores legendarios',
	p_channel_clips_title: 'Clips de NBA TV',
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: 'Programación',
	p_nba_tv_shows: 'Programas de NBA TV',
	p_nba_tv_no_access_title: 'NBA 24/7: ¡Mantente informado con análisis de partidos, análisis desde el estudio, programación original y más!',
	p_nba_tv_no_access_desc: 'Mira partidos en vivo, además de programas especiales y partidos clásicos on demand.',
	p_nba_tv_no_access_note: 'Se pueden aplicar fechas de restricción a nivel regional',
	tv_show_item_latest_episode: 'Último episodio',
	tv_show_item_no_latest_episode: 'Sin último episodio',
	see_all: 'Ver todo',
	header_menu_watch: 'Ver',
	header_menu_featured: 'Destacado',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'League Pass',
	players: 'Jugadores',
	videos: 'Videos',
	teams: 'Equipos',
	most_searched: 'MÁS BUSCADOS',
	no_result: 'Sin datos',
	search_filter_type_most_relevant: 'Lo más relevante',
	search_filter_type_most_viewed: 'Más visto',
	search_filter_type_most_recent: 'Lo más reciente',
	search_filter_type_last_30_days: 'Últimos 30 días',
	search_filter_type_last_6_months: 'Últimos 6 meses',
	search_result_label: 'Resultados de la búsqueda para \'{keyword}\'',
	search_result_info: 'Ver todos los resultados para {keyword}',
	search_placeholder: 'Buscar en la biblioteca de videos',
	load_more: 'Carga más...',
	button_subscribe: 'Suscribir',
	button_sign_in: 'Iniciar sesión',
	p_league_pass_no_access_title: '¡Mira partidos en vivo o en repetición en cualquier dispositivo, incluidos tu computadora, teléfono y TV!',
	p_league_pass_no_access_desc: 'Tu boleto a la acción: mira toda la liga o tu equipo favorito, elige un solo partido o mira más opciones.',
	p_league_pass_no_access_note: 'Se aplican términos y condiciones',
	category_title: 'Video',
	p_video_playlist_title: 'Lista de reproducción',
	p_no_access_league_pass_title: 'Desbloquear NBA League Pass para mirar:',
	p_no_access_league_pass_desc: 'Tu boleto a la acción: mira toda la liga o tu equipo favorito, elige un solo partido o mira más opciones.',
	p_no_access_league_pass_terms: 'Se aplican términos y condiciones',
	p_no_access_league_pass_geo_desc: 'Según tu ubicación actual, no puedes ver este partido a través de NBA League Pass y NBA TV. Un archivo de estos partidos estará disponible 3 días después de la transmisión para los suscriptores de NBA League Pass. Consulta los horarios de las emisoras de radio y televisión locales para saber dónde encontrar las transmisiones en tu zona.',
	p_no_access_league_pass_not_found_desc: 'Lo sentimos, no se encontró el video que solicitaste.',
	p_no_access_event_not_found_desc: 'Lo sentimos, no se encontró el evento que solicitaste.',
	p_no_access_nba_tv_title: 'Desbloquea NBA TV para mirar:',
	p_no_access_nba_tv_desc: 'Mira partidos en vivo, además de programas y partidos clásicos on demand.',
	p_no_access_nba_tv_terms: 'Se aplican términos y condiciones',
	p_no_access_nba_tv_geo_desc: 'Según tu ubicación actual, no puedes ver este partido a través de NBA League Pass y NBA TV. Un archivo de estos partidos estará disponible 3 días después de la transmisión para los suscriptores de NBA League Pass. Consulta los horarios de las emisoras de radio y televisión locales para saber dónde encontrar las transmisiones en tu zona.',
	p_no_access_nba_tv_not_found_desc: 'Lo sentimos, no se encontró el canal que solicitaste.',
	p_no_access_up_next: 'A continuación:',
	p_video_completed_title: 'Lista de reproducción completa',
	p_video_completed_desc: 'Vuelve a navegar o echa un vistazo a la siguiente lista de reproducción',
	p_video_share_to: 'Compartir en:',
	p_video_more_to_watch: 'Más para ver:',
	p_event_section_title: 'EVENTO',
	p_event_playlist_title: 'Lista de reproducción',
	p_event_button_watch: 'Ver',
	p_event_button_listen: 'Escuchar',
	p_event_button_ticket: 'Boleto',
	notfound: 'Lo sentimos, no se encontró la página que solicitaste.',
	notfound_desc: 'Comprueba si la URL es correcta. <br/> También puedes buscar el contenido que desees utilizando el mapa del sitio o la herramienta de búsqueda.',
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: 'Tu cuenta de NBA League Pass ha alcanzado su número de transmisiones máximo. Toca \'Continuar\' para seguir viendo en este dispositivo.',
	modal_pcm_custom: 'Continuar',
	modal_pcm_close: 'Cancelar',
	modal_adobe_concurrency_header_title: 'Se perdió la conexión del video',
	modal_adobe_concurrency_body_title: '',
	modal_adobe_concurrency_body_description: 'Tu transmisión se cerró. Las posibles razones incluyen el límite máximo de transmisiones simultáneas alcanzadas, la pérdida de red o un error técnico. Vuelve a iniciar sesión y selecciona un canal para continuar.',
	modal_adobe_concurrency_close: 'Terminado',
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: 'Este video no se puede reproducir en tu dispositivo. Haz clic <a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'>AQUÍ</a> para obtener más ayuda.',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: 'ACEPTAR',
	freesample_notice_time: 'Tiempo restante',
	freesample_notice_title: 'Disfruta tus {0} minutos de acceso',
	freesample_notice_desc: 'Suscríbete a un paquete completo de League Pass para continuar teneniendo  acceso al contenido una vez que pasen tus {0} minutos.',
	freesample_notice_subscribe_button: 'Suscribir',
	freesample_notice_cancel_button: 'Cancelar en cualquier momento',
	freesample_popup_title: 'TU ACCESO HA TERMINADO',
	freesample_popup_subtitle: 'Suscríbete a League Pass para ver más excelente contenido de la NBA.',
	freesample_popup_link: '¡CONOCE MÁS!',
	freesample_popup_get_minutes_button: 'OBTÉN {0}  MINUTOS',
	reg_required_desc: 'Debes iniciar sesión para ver este contenido',
	favorite_teams_title: 'Equipos favoritos',
	bookmarked_title: 'Guardado',
	watch_history_title: 'Continuar viendo',
	game_schedule_title: 'Horario del partido',
	recommended_title: 'Recomendado',
	season_text: 'Temporada',
	section_tv_provider_title: 'Mi proveedor de TV',
	section_tv_provider_desc: 'Obtén acceso a partidos en vivo y transmisiones de tu proveedor de televisión.',
	section_tv_provider_faq: 'Preguntas frecuentes sobre proveedores de TV',
	section_tv_provider_sign_out: 'Cerrar sesión',
	header_menu_account_my_account: 'Mi cuenta',
	header_menu_account_manage_account: 'Administrar cuenta',
	header_menu_account_favorite_teams: 'Equipos favoritos',
	header_menu_account_favorite_players: 'Jugadores favoritos',
	header_menu_account_viewing_history: 'Historial de visualización',
};
